import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { addMagritteNotification } from 'store/models/notification';
import { setDataSourceAccounts, setVisibleSourceAccounts, SourceAccountData } from 'store/models/sourceAccounts';
import { AppThunkAction } from 'store/utils';

export const fetchSourceAccounts =
    (campaignId: number): AppThunkAction =>
    async (dispatch) => {
        dispatch([setLoadCampaignAdminAction(true), setIdAdminAction(campaignId)]);
        try {
            const data = await fetcher.get<unknown, SourceAccountData[]>(
                `/api/v1/backoffice/info/${campaignId}/api_source_accounts`
            );
            dispatch([setVisibleSourceAccounts(true), setDataSourceAccounts(data)]);
        } catch (error) {
            dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
            throw error;
        } finally {
            dispatch(setLoadCampaignAdminAction(false));
        }
    };
